import React, { memo } from 'react';
import ReactDOM from 'react-dom';
import LogoAnimation from './LogoAnimation';
import loaderGif from '../assets/loader.gif';
import './LoadingSpinner.css';

// ── Switch loaders here ─────────────────────────────────────
// Change to 'logo' to revert to the animated logo loader
export const LOADER_VARIANT: 'logo' | 'gif' = 'gif';
// ────────────────────────────────────────────────────────────

interface LoadingSpinnerProps {
  variant?: 'logo' | 'gif';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = memo(({ variant = LOADER_VARIANT }) => {
  const isGif = variant === 'gif';
  return ReactDOM.createPortal(
    <div className={`loading-container${isGif ? ' loading-container--gif' : ''}`}>
      <div className={`loading-spinner${isGif ? ' loading-spinner--gif' : ''}`}>
        <div className="loading-logo">
          {isGif ? (
            <img src={loaderGif} alt="Loading..." className="loading-gif" />
          ) : (
            <LogoAnimation />
          )}
        </div>
        {!isGif && <p className="loading-text">Loading...</p>}
      </div>
    </div>,
    document.body
  );
});

LoadingSpinner.displayName = 'LoadingSpinner';

export type { LoadingSpinnerProps };
export default LoadingSpinner;
